<template>
    <div>
        <div v-if="loading">
            <h2 class="mt-3 ml-3">Cargando...</h2>
        </div>
        <div v-else class="vx-row flex justify-center">
            <div class="vx-col sm:w-4/5 lg:w-2/3 md:w-3/4 pt-6">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="https://evolugy.mayfer.software/Evolugy/app-assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div v-if="!hasActivePatient">
                        <h5>Paciente Nuevo</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para crear tu perfil como paciente.</p>
                    </div>
                    <div v-else>
                        <h5>Ficha Médica</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para crear completar tu perfil como paciente.</p>
                    </div>

                    <div class="mt-5">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            :title="null" :subtitle="null"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            finishButtonText="Envíar"
                        >
                            <tab-content title="Datos" class="mb-5" :before-change="validatePatientData">
                                <!--:before-change=" validatePatientData" -->
                                    <form data-vv-scope="patient-data">
                                    <!-- tab 1 content -->
                                    <div class="vx-row">
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Nombre(s)*</p>
                                            <vs-input placeholder="Nombre(s)" v-model="patientData.first_name" name="nombres" v-validate="'required'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('patient-data.nombres') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Apellido(s)*</p>
                                            <vs-input placeholder="Apellido(s)" v-model="patientData.last_name" name="apellidos" v-validate="'required'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('patient-data.apellidos') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Correo*</p>
                                            <vs-input placeholder="Correo" v-model="patientData.email"
                                             :disabled="hasActivePatient"
                                             name="email" v-validate="'required|email'" class="w-full" />
                                            <span class="text-danger">{{ errors.first('patient-data.email') }}</span>
                                        </div>
                                        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 mt-5">
                                            <p>Sexo*</p>
                                            <ul class="ml-2 mt-2 flex">
                                                <li class="ml-3 mb-2 inline">
                                                    <vs-radio v-model="patientData.gender" name="genero" v-validate="'required'" vs-value="male">
                                                    Másculino
                                                    </vs-radio>
                                                </li>
                                                <li class="ml-3 mb-2">
                                                    <vs-radio v-model="patientData.gender" name="genero" v-validate="'required'" vs-value="female">
                                                    Femenino
                                                    </vs-radio>
                                                </li>
                                            </ul>
                                            <span class="text-danger">{{ errors.first('patient-data.genero') }}</span>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p>Fecha de Nacimiento*</p>
                                            <flat-pickr class="w-full" :config="configdateTimePicker2" v-model="currentPatientData.dob" placeholder="Seleccionar Fecha"
                                                    v-validate="'required'" name="fecha" />
                                                <span class="text-danger w-full">{{ errors.first('patient-data.fecha') }}</span>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p class="mb-1">Número Celular*</p>
                                            <div class="vx-row">
                                                <vue-country-code class="vx-col w-1/10 ml-4 flex max-height:70%"
                                                :preferredCountries="['gt', 'mx', 'sv', 'ni', 'hn', 'cr']"
                                                @onSelect="saveCode"
                                                >
                                                </vue-country-code>
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de teléfono" name="celular" v-validate="'required|numeric'" v-model="patientData.phone[0]" />
                                                    <span class="text-danger">{{ errors.first('patient-data.celular') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="vx-col  w-full mt-5">
                                            <p class="mb-1">Número de Teléfono</p>
                                            <div class="vx-row">
                                                <div class="vx-col w-1/3">
                                                    <v-select placeholder="Código de Extensión" :options="['+502','+503', '+504', '+505']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                </div>
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de teléfono" v-model="patientData.phone[1]" />
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="vx-col  w-full mt-5">
                                            <p>Identificación</p>
                                            <div class="vx-row">
                                                <div class="vx-col w-1/3">
                                                    <v-select placeholder="Documento" v-model="patientData.meta.personal_id_type"
                                                    :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                </div>
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de identificación" v-model="patientData.meta.personal_id" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col w-full mt-6">
                                            <h5>Dirección de Residencia</h5>
                                            <p class="mt-3">Dirección</p>
                                            <vs-input type="text" placeholder="Dirección"  v-model="patientData.address" class="w-full" />
                                            <p class="mt-3">Complemento</p>
                                            <vs-input type="text" placeholder="Complemento de Dirección"  v-model="patientData.address_2" class="w-full" />
                                            <p class="mt-3">Zona</p>
                                            <vs-input type="text" placeholder="Zona"  v-model="patientData.zone" class="w-full" />
                                            <p class="mt-4">País</p>
                                            <v-select placeholder="Selecciona el País" label="name" v-model="patientData.country" class="" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                            <p class="mt-4">Ciudad</p>
                                            <v-select placeholder="Selecciona la Ciudad/Estado" class="" v-model="patientData.city" :options="getStates" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                        </div>
                                        <div class="vx-col  w-full mt-6 mb-2">
                                            <h5 class="my-2">¿Cómo te enteraste de nosotros?</h5>
                                            <div class="vx-row ">
                                                <div class="vx-col flex flex-col items-center w-full">
                                                    <v-select placeholder="Selecciona el origen" class="mt-2 w-1/2" v-model="patientData.meta.doctorRef"
                                                        :options="['Google','Referidos', 'Redes Sociales', 'Por mi Seguro', 'Ví su clínica', 'Otro']"
                                                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                        />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col  w-full mt-5" v-if="patientData.meta.doctorRef == 'Referidos'">
                                            <p>Persona que lo refirio</p>
                                            <div class="vx-row">
                                                <div class="vx-col w-full md:w-1/2 lg:w-1/2 sm:w-full">
                                                    <vs-input class="inputx w-full" placeholder="Nombre" v-model="patientData.meta.doctorRefName" />
                                                </div>
                                                <div class="vx-col w-full md:w-1/2 lg:w-1/2 sm:w-full">
                                                    <vs-input class="inputx w-full" placeholder="Apellido" v-model="patientData.meta.doctorRefLastName" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col  w-full my-5" v-if="patientData.meta.doctorRef == 'Referidos'">
                                            <p>Teléfono de la persona que lo refirió</p>
                                            <div class="vx-row">
                                                <div class="vx-col w-1/3">
                                                    <vs-input class="inputx w-full" placeholder="Código de área" v-model="patientData.meta.doctorRefPhoneExt" />
                                                </div>
                                                <div class="vx-col w-2/3 ">
                                                    <vs-input class="inputx w-full" placeholder="Número de teléfono" v-model="patientData.meta.doctorRefPhone" />
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="vx-col  w-full mt-5">
                                            <h5>¿Es cita de control a una consulta anterior?</h5>
                                            <div class="vx-row ">
                                                <div class="vx-col">
                                                    <ul class="centerx ml-5 mt-3">
                                                        <li>
                                                            <vs-radio v-model="patientData.meta.prev_consultation_control" name="prev_consultation_control" :vs-value="true">Si</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio v-model="patientData.meta.prev_consultation_control" name="prev_consultation_control" :vs-value="false">No</vs-radio>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="vx-col w-full mt-5">
                                             <div class="vx-row ">
                                                <div class="vx-col w-full">
                                                    <h5>Seguros y planes médicos</h5>
                                                </div>
                                            </div>
                                            <div class="vx-row mt-5">
                                                <div class="vx-col w-1/2">
                                                    <p class="mb-1">Aseguradora o plan médico</p>
                                                    <vs-input class="inputx w-full" placeholder="Aseguradora o plan médico" v-model="patientData.meta.insurance_plan" />
                                                </div>
                                                <div class="vx-col w-1/2">
                                                    <p class="mb-1">Póliza o número de afiliado</p>
                                                    <vs-input class="inputx w-full" placeholder="Póliza o número de afiliado" v-model="patientData.meta.insurance_num" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </tab-content>

                            <tab-content title="Antecedentes" class="mb-5" :before-change="validateMidStep">
                                <div class="vx-row mb-5">
                                    <div class="vx-col w-full">
                                        <h5>Ficha del Paciente</h5>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Alergías</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.allergyBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.allergyBool">
                                        <vs-textarea v-model="patientData.meta.allergyVal" label="Detalle Alergías" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Enfermedades</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.conditionBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.conditionBool">
                                        <vs-textarea v-model="patientData.meta.conditionVal" label="Detalle Enfermedades" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>¿Utiliza medicamentos?</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.MedsBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.MedsBool">
                                        <vs-textarea v-model="patientData.meta.MedsVal" label="Detalle Medicamentos" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>¿Tiene tratamientos?</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.treatmentBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.treatmentBool">
                                        <vs-textarea v-model="patientData.meta.treatmentVal" label="Detalle Tratamiento" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>Antecedentes de Cáncer en la familia</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.cancerBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.cancerBool">
                                        <vs-textarea v-model="patientData.meta.cancerVal" label="Detalle Antecedentes de Cancer" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Cirugías</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="patientData.meta.surgeryBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="patientData.meta.surgeryBool">
                                        <vs-textarea v-model="patientData.meta.surgeryVal" label="Detalle Cirugías" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>                                
                                <div class="vx-row mt-4">
                                    <div class="vx-col lg:w-1/4 sm:w-full md:w-1/3">
                                        <p>¿Usted fuma?</p>
                                        <ul class="centerx ml-5 mt-3 flex">
                                            <li class="inline mr-4">
                                                <vs-radio v-model="patientData.meta.smoke" name="smoke" :vs-value="true">Si</vs-radio>
                                            </li>
                                            <li>
                                                <vs-radio v-model="patientData.meta.smoke" name="smoke" :vs-value="false">No</vs-radio>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="vx-col lg:w-3/4 sm:w-full md:w-2/3" v-if="patientData.meta.smoke">
                                        <p>Si fuma, cuantos cigarros al día y desde hace cuento tiempo</p>
                                        <vs-textarea v-model="patientData.meta.smokeDetail" class="" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Grupo sanguineo</p>
                                        <div class="flex ml-4 w-full">
                                            <v-select :options="['A+','O+','AB+','A-','O-','B-','AB-']" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                v-model="patientData.meta.blood_type" class="mb-4 md:mb-0 inputx w-full" 
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Peso (Libras)</p>
                                        <div class="flex ml-4 w-full">
                                            <vs-input class="inputx w-full" placeholder="Peso (Libras)" v-model="patientData.meta.weight" />
                                        </div>
                                    </div>
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Estatura (Metros)</p>
                                        <div class="flex ml-4 w-full">
                                            <vs-input class="inputx w-full" placeholder="Estatura (Metros)" v-model="patientData.meta.height" />
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col  w-full pl-2">
                                        <p>Hace Ejercicio</p>
                                        <div class="vx-row">
                                            <div class="vx-col">
                                                <ul class="centerx ml-5 mt-3 flex">
                                                    <li class="inline mr-2">
                                                        <vs-radio v-model="patientData.meta.exercise" name="exercise" :vs-value="true">Si</vs-radio>
                                                    </li>
                                                    <li>
                                                        <vs-radio v-model="patientData.meta.exercise" name="exercise" :vs-value="false">No</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-4" v-if="patientData.meta.exercise">
                                        <p>Tipo de ejercicio</p>
                                        <div class="vx-row ">
                                            <div class="vx-col flex flex-col items-center w-full">
                                                <v-select placeholder="Tipo de ejercicio" class="mt-1 w-full"  v-model="patientData.meta.exerciseType"
                                                    :options="['Caminar a paso ligero','Caminata regular', 'Trotar', 'Yoga', 'Aerobicos', 'Nadas', 'Bicicleta', 'Correr', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                    />
                                            </div>
                                        </div>
                                        <div class="vx-row mt-4 ">
                                            <div class="vx-col w-full">
                                               <p>¿Con qué frecuencia?</p>
                                            </div>
                                        </div>
                                        
                                        <div class="vx-row">
                                            <div class="vx-col w-full">
                                                <v-select placeholder="Frecuencia de ejercicio" class="mt-1 w-full"  v-model="patientData.meta.exerciseFreq"
                                                    :options="['Una vez a semana','Dos veces a la semana', 'Tres veces a la semana', 'Cuatro veces a la semana', 'Cinco veces a la semana', 'Seis veces a la semana', 'Todos los días']" 
                                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                    />
                                            </div>
                                            <div class="vx-col w-full mt-4">
                                                <p>Tiempo (min)</p>
                                                <vs-input class="inputx w-full" placeholder="Tiempo (min)" v-model="patientData.meta.exerciseTime" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-full pl-2" v-if="patientData.meta.height">
                                        <p class="mb-2">Estatura</p>
                                        <div class="flex ml-4">
                                            <vs-input placeholder="Estatura" class="inline" 
                                                v-model="patientData.meta.height"
                                            />
                                            <p class="ml-3 mt-3 inline">Metros</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-full pl-2" v-if="patientData.meta.weight">
                                        <p class="mb-2">Peso</p>
                                        <div class="flex ml-4">
                                            <vs-input placeholder="Estatura" class="inline" 
                                                v-model="patientData.meta.weight"
                                            />
                                            <p class="ml-3 mt-3 inline">Libras</p>
                                        </div>
                                    </div>
                                </div> -->
                            </tab-content>
                            <!-- tab 3 content -->
                            <tab-content title="Confirmación" class="mb-5" :before-change="validateLastStep">
                                <form data-vv-scope="last-step">
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-5"> 
                                            <h4>Verificar Información</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Información Personal</h5>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-5 ml-4">
                                            <h6 class="inline mr-2">Nombres:</h6>
                                            <p class="inline"> {{patientData.first_name}} </p>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Apellidos:</h6>
                                            <p class="inline"> {{patientData.last_name}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Correo Electrónico:</h6>
                                            <p class="inline"> {{patientData.email}} </p>
                                        </div>
                                        <div class="vx-col  w-full md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Sexo:</h6>
                                            <p class="inline"> {{patientData.gender}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Fecha de Nacimiento:</h6>
                                            <p class="inline"> {{new Date(patientData.dob).toLocaleDateString('es-ES', dateStringOptions) }} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Celular de Contacto:</h6>
                                            <p class="inline"> { {{patientData.phone[0]}}  </p>
                                        </div>
                                        <!-- <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.phone[1]">
                                            <h6 class="inline mr-2">Teléfono de Contacto:</h6>
                                            <p class="inline"> {{patientData.meta.phoneExt[0]}} {{patientData.phone[1]}}  </p>
                                        </div> -->
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.meta.personal_id">
                                            <h6 class="inline mr-2">Identificación:</h6>
                                            <p class="inline"> {{patientData.meta.personal_id_type}} {{patientData.meta.personal_id}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.address">
                                            <h6 class="mr-2">Dirección de Residencia:</h6>
                                            <p class="inline"> {{patientData.address}} {{patientData.address_2 ? patientData.address_2 : ''}} </p>
                                            <p v-if="patientData.zone"> {{`Zona: ${patientData.zone} `}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-5" v-if="patientData.country && patientData.city">
                                            <p class="inline mr-1">{{patientData.country.name}}</p>
                                            <p class="inline mr-1">{{patientData.city}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.meta.doctorRefName">
                                            <h6 class="inline mr-2">Persona que lo refirió:</h6>
                                            <p class="inline mr-1">{{patientData.meta.doctorRefName}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 mb-4 ml-4" v-if="patientData.meta.doctorRefPhone">
                                            <h6 class="inline mr-2">Número del Referido:</h6>
                                            <p class="inline mr-1">{{patientData.meta.doctorRefPhoneExt}} {{patientData.meta.doctorRefPhone}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-4">
                                            <h5>Seguros y planes médicos</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-3" >
                                            <div class="vx-row">
                                                <div class="vx-col w-1/2">
                                                    <strong class="mb-1">Aseguradora:</strong>
                                                    <p> {{patientData.meta.insurance_plan.length > 0 ? patientData.meta.insurance_plan : 'Sin detalle' }} </p>
                                                </div>
                                                <div class="vx-col w-1/2">
                                                    <strong class="mb-1">Póliza o número de afiliado:</strong>
                                                    <p> {{patientData.meta.insurance_num.length > 0 ? patientData.meta.insurance_num : 'Sin detalle' }} </p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <vs-divider></vs-divider>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Ficha Médica</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-2">
                                            <h6 class="inline mr-2">Alergías:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.allergyBool ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.allergyBool"> {{patientData.meta.allergyVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Enfermedades:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.conditionBool ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.conditionBool"> {{patientData.meta.conditionVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Medicamentos:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.MedsBool ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.MedsVal"> {{patientData.meta.MedsVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Antecedentes de Cáncer:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.cancerBool ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.cancerBool"> {{patientData.meta.cancerVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Cirugías:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.surgeryBool ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.surgeryBool"> {{patientData.meta.surgeryVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Fuma:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{patientData.meta.smoke ? 'Si':'No'}}  </p>
                                            <p v-if="patientData.meta.smoke"> {{patientData.meta.smokeDetail}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Tipo de Sangre:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.meta.blood_type">
                                            <p class="inline"> {{patientData.meta.blood_type}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Estatura:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.meta.height">
                                            <p class="inline"> {{patientData.meta.height}} Metros  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Peso:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="patientData.meta.weight">
                                            <p class="inline"> {{patientData.meta.weight}} Libras  </p>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-col w-full mt-5 flex flex-col items-center">
                                            <h6 class="my-3">Términos y Condiciones</h6>
                                            <a href="/pages/patient/terms-cond" target="_blank" class="mt-3">
                                                <feather-icon icon="ExternalLinkIcon" class="mr-2" />
                                                Consultar términos y Condiciones
                                            </a>
                                            <ul class="centerx">
                                                <li>
                                                <vs-checkbox class="mt-4" name="terminos_condiciones" v-validate="'required:true'" v-model="termsCond">Acepto los términos y Condiciones</vs-checkbox>
                                                <span class="text-danger">{{ errors.first('last-step.terminos_condiciones') }}</span>
                                                </li>
                                            </ul>
                                            <ul class="centerx">
                                                <li>
                                                <vs-checkbox class="mt-4" name="consentimiento" v-validate="'required:true'" v-model="consent">
                                                    Doy mi consentimiento legal <br> para evaluación médica, <br> diagnosticada y terapéutica.
                                                </vs-checkbox>
                                                <span class="text-danger">{{ errors.first('last-step.consentimiento') }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <vs-divider></vs-divider>
                                    </div>
                                </form>
                                
                            </tab-content>
                        </form-wizard>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'

// country state picker functions
import * as CSP from 'country-state-picker';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

export default {
  data () {
    return {
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      patientData: {
          first_name: null,
          last_name: null,
          gender: null,
          dob: null,
          phone: [],
          email: null,
          address: null,
          address_2: null,
          country: {},
          role: 'patient',
          active: true,
          city: null,
          meta: {
              personal_id: null,
              personal_id_type: null,
              phoneExt: [],
              doctorRef: null,
              doctorRefName: null,
              doctorRefLastName: null,
              doctorRefPhone: null,
              doctorRefPhoneExt: null,
              prev_consultation_control: null,
              insurance_num: '',
              insurance_plan: '',
              exercise: null,
              exerciseFreq: null,
              exerciseType: null,
              exerciseTime: null,
              allergyBool: false,
              allergyVal: null,
              conditionBool: false,
              conditionVal: null,
              MedsBool: false,
              MedsVal: null,
              surgeryBool: false,
              surgeryVal: null,
              cancerBool: false,
              cancerVal: null,
              smoke: null,
              smokeDetail: null,
              weight: null,
              height: null,
              blood_type: null
          }
      },
      currentPatientData: {},
      termsCond: null,
      consent: null,
      hasActivePatient: false,
      loading: true,
    }
  },
      configdateTimePicker2: {
            enableTime: false,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd M Y',
            defaultDate: new Date(),
            locale: ES
      },
  methods: {
      saveCode({name, iso2, dialCode}) {
        this.patientData.meta.phoneExt[0] = dialCode
        console.log(this.patientData.meta.phoneExt[0])
    },
    submitData () {
        this.patientData.phone[0] = this.patientData.meta.phoneExt[0] + this.patientData.phone[0]
        this.patientData.active = true;

        if(this.patientData.country.name){
            this.patientData.country = this.patientData.country.name;
        }
        
        if(this.hasActivePatient){
            this.$store.dispatch('editUserPublic', this.patientData).then(response => {
            console.log(response); 
            
            window.location.href = '/links/confirm-p';                         
        }, error => {
            console.error(error.response);
            
        });
        } else {
            this.patientData.meta.doctor_id = this.$route.params.doctor_id;
            this.$store.dispatch('registerPatientPublic', this.patientData).then(response => {
                
                console.log(response);
                window.location.href = '/links/confirm-p';  
                            
            }, error => {
                console.error(error.response);
                
            });
        }

       
    },
    scroll(){
       window.scroll({
        top: 50,
        left: 0,
        behavior: 'smooth'
      });
    },
    validatePatientData(type) {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('patient-data').then(result => {
                if (result) {
                    this.scroll();
                    resolve(true);
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    validateMidStep(type) {
         return new Promise((resolve, reject) => {
           setTimeout(() => {
               this.scroll();
               resolve(true);
           }, 100);
        });
    },
    validateLastStep(type) {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('last-step').then(result => {
                if (result) {
                    this.submitData();
                    this.scroll();
                    resolve(true);
                } else {
                    console.log('correct all  values');
                    reject('correct all values');
                }
            })
        });
    }
  },
  computed: {
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.patientData.country.code);
    },
  },
  created(){
      console.log(this.$route);
      if(this.$route.query.pid){
          console.log(this.$route.query.pid);
          this.hasActivePatient = true;
        this.$store.dispatch('getUserDataByIdPublic', this.$route.query.pid).then(response => {
                console.log(response);
                this.currentPatientData = JSON.parse(JSON.stringify(response.data.data.user));
                var tempMeta = {...this.patientData.meta, ...this.currentPatientData.meta};
                this.patientData = {...this.patientData, ...this.currentPatientData};

                this.patientData.meta = tempMeta;
                console.log(this.patientData)
                this.loading = false;
            }, error => {
                console.error(error);
            }
        ); 
      } else { 
          this.loading = false;
          this.hasActivePatient = false;
      }
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
.vue-country-select {
      max-height: 70%;
      z-index: 1000;
  }
body{
        touch-action: manipulation;
    }
</style>